import React, { useEffect, useMemo, useRef, useState } from 'react';
import '../../../index.scss';
import './styles.css';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { TextField, makeStyles } from '@material-ui/core';
// ICON

import LocalPhone from '@material-ui/icons/LocalPhone';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import { isType, isType3, isTypeBK, localeTw, userTypeList } from 'main_consts';

// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { Iobject } from 'main_type';
import { setLoadingRedux, setUserInfoRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import MenuIcon from '@material-ui/icons/Menu';
import Header from 'components/Header';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { green } from '@material-ui/core/colors';
import { FileCopy } from '@material-ui/icons';
import { IuserInfo } from 'reducers/shareData/types';
import Radio from '../../../components/Radio';
// component
import Menu, { IMenu } from '../../../components/Menu';
import {
  formatDateTime,
  getColWidthByField,
  getDateDayPlus,
  getExpressName,
  getWarehouse,
  inputChange,
  radioChange,
  initWhrehhouse,
  formatDate,
  daFormatTrans,
} from '../../../main_func';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getLoginInfo,
  getLoginInfoGuest,
  getQRCodeSearch,
  getSearch,
  postApiAndFunctionName,
  postExcel,
  postPDF,
  postSearch,
  snackBarRsp,
} from '../../../main_api';

// import Table from '../../../components/Material/Table/index';
import { Imaster, IresultDetail, ImasterList } from './type';
// 區分與原Table css 樣式
import Table from './Table';
import Input from './Input';
import Invoiceform from './Invoice';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .ag-root-wrapper': {
      backgroundColor: 'transparent !important', // 覆寫背景色為透明
    },
    '& .ag-row': {
      backgroundColor: 'transparent !important', // 覆寫背景色為透明
    },
  },
}));

/** 商業發票資料查詢 */
const InvoiceQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const [searchUnprotectedSucceeded, setSearchUnprotectedSucceeded] =
    useState(false);

  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  useEffect(() => {
    let isMounted = true;

    const refreshLoginState = async () => {
      try {
        const response = await getLoginInfo();
        const result = response?.data as {
          status?: number;
          data?: Partial<IuserInfo>;
        };

        if (!isMounted || result?.status !== 0 || !result?.data) {
          return;
        }

        dispatch(setUserInfoRedux(result.data as IuserInfo));
      } catch (error) {
        // 未登入或 session 過期時，保留 guest 模式，不跳轉登入頁
        console.warn('login recheck failed:', error);
      }
    };

    refreshLoginState();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  const classes = useStyles();

  const { enqueueSnackbar } = useSnackbar();
  const menuProps: IMenu = {
    guest: true, // 設定 guest 參數為 true
  };
  // call login
  const defaultDetail: IresultDetail = {
    itemNo: '',
    unitPrice: '',
    qty: '',
    goodsSpec: '',
    qtyUnit: '',
    nwt: '',
    nwtUnit: '',
    currency: '',
    totalAmount: '',
  };
  const masterDefaultValue: Imaster = {
    /** 訂單號碼 */
    poNo: '',
    // 分號
    hawbNo: '',
    // QRCode
    qrCodeData: '',
    /** 總金額 */
    amount: '',

    /** 訂單開立者統一編號 */
    poCompanyId: '',
    /** 電話訂單編號 */
    telId: '',
    /** 母訂單號碼 */
    hdPono: '',

    // 銷售人姓名
    seContact: '',
    // 銷售人電話
    seContactTel: '',
    // 銷售人地址
    seAddress: '',

    // 收貨人姓名
    cnContact: '',
    // 收貨人電話
    cnContactTel: '',
    // 收貨人地址
    cnAddress: '',

    // 訂購人(買方)姓名
    byContact: '',
    // 訂購人(買方)電話
    byContactTel: '',
    // 寄件人姓名
    spContact: '',
    // 寄件人電話
    spContactTel: '',
    // 寄件人地址
    spAddress: '',
    // 訂單日期
    poDate: '',

    ehuPoItemDTOs: [],
  };

  const defaultMasterList: ImasterList = {
    ehuPoMasterDTOs: [],
    hdPoNoList: false,
  };
  const apiName = 'invoiceQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [submitKey, setSubmitKey] = useState('search');
  const [randomValue, setRandomValue] = useState(Math.random());
  const [masterList, setMasterList] = useState<ImasterList>(defaultMasterList);
  // const [value, setValue] = useState('');
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [rowData, setRowData] = useState<Imaster[]>([]);

  function isAdmin(): boolean {
    if (!userType) return false;
    return (
      isTypeBK(userType) ||
      isType(userTypeList.type1, userType) ||
      isType(userTypeList.type4, userType) ||
      isType(userTypeList.admin, userType) ||
      isType(userTypeList.topType, userType)
    );
  }

  const [value, setValue] = useState(() => {
    if (typeof window === 'undefined') return '';

    const urlParams = new URLSearchParams(window.location.search);
    const urlQrcode = urlParams.get('value');
    const referringUrl = document.referrer;
    const ALLOWED_REFERRER_PATTERN =
      /http:\/\/(127\.0\.0\.1|localhost)|https:\/\/[^/]*\.tradevan\.com\.tw/;

    const isAllowed = ALLOWED_REFERRER_PATTERN.test(referringUrl);
    if (urlQrcode) {
      if (isAllowed) {
        // 特定來源：清空快取
        localStorage.removeItem('qrcode');
      } else {
        // 一般來源：寫入快取
        localStorage.setItem('qrcode', urlQrcode);
      }
      return urlQrcode;
    }
    // 無 URL 參數：清空快取
    localStorage.removeItem('qrcode');
    return '';
  });

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>,
    poNo?: string,
    hawbNo?: string
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setOpenSearchTable(false);
    dispatch(setLoadingRedux(true));
    const result = await postSearch(apiName, {
      poNo: master.poNo ? master.poNo : poNo,
      hawbNo: master.hawbNo ? master.hawbNo : hawbNo,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      setMasterList(defaultMasterList);
      return;
    }

    const { data: dataTemp } = result.data;
    const data = dataTemp as ImasterList;
    if (data && data.ehuPoMasterDTOs && data.ehuPoMasterDTOs.length > 0) {
      setMasterList((prev) => ({
        ...prev,
        ehuPoMasterDTOs: data.ehuPoMasterDTOs,
      }));
      setMaster(data.ehuPoMasterDTOs[0]);
      setRandomValue(Math.random());
    } else {
      setMaster(masterDefaultValue);
      setMasterList(defaultMasterList);
    }
    setRandomValue(Math.random());
  };

  const handleSearchHawbNo = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await postSearch(apiName, {
      poNo: master.poNo,
      hawbNo: master.hawbNo,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      setMasterList(defaultMasterList);
      setOpenSearchTable(false);
      return;
    }

    const { data: dataTemp } = result.data;
    const data = dataTemp as ImasterList;
    if (data && data.ehuPoMasterDTOs && data.ehuPoMasterDTOs.length > 0) {
      if (!data.hdPoNoList) {
        handleSearch(
          e,
          data.ehuPoMasterDTOs[0].hdPono,
          data.ehuPoMasterDTOs[0].hdPono
        );
        setOpenSearchTable(false);
      } else {
        setMasterList((prev) => ({
          ...prev,
          ehuPoMasterDTOs: data.ehuPoMasterDTOs,
        }));
        // setMaster(data.ehuPoMasterDTOs[0]);
        setRowData(data.ehuPoMasterDTOs);
        setRandomValue(Math.random());
        setOpenSearchTable(true);
      }
    } else {
      setMaster(masterDefaultValue);
      setMasterList(defaultMasterList);
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleButtonClick = (gridData: any) => {
    handleSearch(undefined, gridData.hdPono, gridData.hawbNo);
  };

  const gridRef = useRef<any>(undefined);
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = [
      {
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        // checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        minWidth: 70,
        width: 8,
        maxWidth: 70,
        filter: false,
        sortable: true,
        editable: false,

        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '訂單號碼',
        field: 'poNo',
        width: 150,
      },
      {
        headerName: '分提單號碼',
        field: 'hawbNo',
        width: 150,
      },
      {
        headerName: '收貨人電話',
        field: 'cnContactTel',
        width: 150,
      },
      {
        headerName: '',
        field: 'action',
        cellRendererFramework: (params: any) => (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleButtonClick(params.data)}
          >
            查詢
          </Button>
        ),
      },
    ];

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 20,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };

  async function showData(urlQrcode: string | null | undefined) {
    if (value || urlQrcode) {
      dispatch(setLoadingRedux(true));
      // await getLoginInfoGuest();
      getQRCodeSearch(apiName, {
        qrCodeData: urlQrcode || value,
      }).then((item) => {
        if (!snackBarRsp(enqueueSnackbar, item)) {
          dispatch(setLoadingRedux(false));
          setMasterList(defaultMasterList);
          return;
        }
        const { data: dataTemp } = item.data;

        const data = dataTemp as ImasterList;
        if (data && data.ehuPoMasterDTOs && data.ehuPoMasterDTOs.length > 0) {
          setSearchUnprotectedSucceeded(true);
          setMasterList((prev) => ({
            ...prev,
            ehuPoMasterDTOs: data.ehuPoMasterDTOs,
          }));
          if (isAdmin()) {
            setMaster(data.ehuPoMasterDTOs[0]);
            setRandomValue(Math.random());
          } else {
            setMaster((prev) => ({
              ...prev,
              cnContact: data.ehuPoMasterDTOs[0].cnContact,
              cnContactTel: data.ehuPoMasterDTOs[0].cnContactTel
                ? data.ehuPoMasterDTOs[0].cnContactTel
                : '',
              poNo: data.ehuPoMasterDTOs[0].poNo
                ? data.ehuPoMasterDTOs[0].poNo
                : '',
              hawbNo: data.ehuPoMasterDTOs[0].hawbNo
                ? data.ehuPoMasterDTOs[0].hawbNo
                : '',
            }));
          }
        } else {
          setMaster(masterDefaultValue);
          setMasterList(defaultMasterList);
        }
      });
      dispatch(setLoadingRedux(false));
    }
  }

  function copyPhone(
    poNo: string | null | undefined,
    hawbNo: string | null | undefined,
    functionName: string
  ) {
    if (poNo && hawbNo) {
      dispatch(setLoadingRedux(true));
      postApiAndFunctionName(apiName, functionName, {
        poNo: poNo || value,
        hawbNo: hawbNo || value,
      }).then((item) => {
        if (!snackBarRsp(enqueueSnackbar, item)) {
          dispatch(setLoadingRedux(false));
          return;
        }
        const { data: dataTemp } = item.data;

        const data = dataTemp as string;
        if (data) {
          setMaster((prev) => ({
            ...prev,
            cnContactTel: data,
          }));

          switch (functionName) {
            case 'prepareTel':
              // android 的#是特殊符號,需轉成%23
              window.location.href = `tel:${data}`.replace('#', '%23');
              break;
            case 'copyTel':
              try {
                navigator.clipboard.writeText(data);
              } catch (error) {
                console.log('copyTel', error);
                break;
              }
              break;
            default:
              console.log(functionName, data);
              break;
          }
        }
        dispatch(setLoadingRedux(false));
      });
    }
  }

  function setlocalStorage() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlQrcode = urlParams.get('value');
    const referringUrl = document.referrer;

    if (urlQrcode) {
      // 寫 localStorage

      if (
        referringUrl === 'https://wehu.tradevan.com.tw/' ||
        referringUrl === 'https://vwehu.tradevan.com.tw/' ||
        referringUrl === 'https://twehu.tradevan.com.tw/' ||
        referringUrl === 'http://127.0.0.1/'
      ) {
        setValue(urlQrcode);
        localStorage.removeItem('qrcode');
      } else {
        localStorage.setItem('qrcode', urlQrcode);

        setValue(urlQrcode);
      }
    } else {
      // 清空 localStorage
      localStorage.removeItem('qrcode');

      setValue('');
    }
  }
  useEffect(() => {
    console.log('userType', userType);
    // setlocalStorage();
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMaster((prev) => ({
      ...prev,
      qrCodeData: event.target.value,
    }));
  };

  const isValidURL = (qrCodeData: string) => {
    if (qrCodeData.startsWith('http://127.0.0.1')) {
      window.parent.location.href = 'http://127.0.0.1:3000/Login';
    } else if (qrCodeData.startsWith('https://localhost')) {
      window.parent.location.href = 'https://localhost:3000/Login';
    } else if (qrCodeData.startsWith('https://vwehu.tradevan.com.tw')) {
      window.parent.location.href = 'https://vwehu.tradevan.com.tw/Login';
    } else if (qrCodeData.startsWith('https://twehu.tradevan.com.tw')) {
      window.parent.location.href = 'https://twehu.tradevan.com.tw/Login';
    } else if (qrCodeData.startsWith('https://wehu.tradevan.com.tw')) {
      window.parent.location.href = 'https://wehu.tradevan.com.tw/Login';
    } else {
      return false;
    }
    return true;
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent newline in the textarea
      if (isValidURL(master.qrCodeData)) {
        window.parent.location.href = master.qrCodeData;
      }
    }
  };

  useEffect(() => {
    console.log('userType', userType);
    showData(null);
  }, [userType]);

  useEffect(() => {
    showData(null);
  }, [value]);

  const handleLogin = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    // setCookie();
    window.opener = null;
    const domain = `${window.location.protocol}//${window.location.hostname}`;

    switch (domain) {
      case 'http://127.0.0.1':
      case 'http://localhost':
      case 'https://vwehu.tradevan.com.tw':
      case 'https://wehu.tradevan.com.tw':
        window.parent.location.href = `${window.location.origin}/Login`;
        break;
      default:
        break;
    }
  };

  const handleSearchUnprotected = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await postApiAndFunctionName(apiName, 'searchUnprotected', {
      poNo: master.poNo,
      hawbNo: master.hawbNo,
    });
    setSearchUnprotectedSucceeded(false);
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      setMasterList(defaultMasterList);
      return;
    }

    const { data: dataTemp } = result.data;
    const data = dataTemp as ImasterList;
    if (data && data.ehuPoMasterDTOs && data.ehuPoMasterDTOs.length > 0) {
      setMasterList((prev) => ({
        ...prev,
        ehuPoMasterDTOs: data.ehuPoMasterDTOs,
      }));
      if (isAdmin()) {
        setMaster(data.ehuPoMasterDTOs[0]);
        setRandomValue(Math.random());
      } else {
        setSearchUnprotectedSucceeded(true);
        setMaster((prev) => ({
          ...prev,
          cnContact: data.ehuPoMasterDTOs[0].cnContact,
          cnContactTel: data.ehuPoMasterDTOs[0].cnContactTel
            ? data.ehuPoMasterDTOs[0].cnContactTel
            : '',
          poNo: data.ehuPoMasterDTOs[0].poNo
            ? data.ehuPoMasterDTOs[0].poNo
            : '',
          hawbNo: data.ehuPoMasterDTOs[0].hawbNo
            ? data.ehuPoMasterDTOs[0].hawbNo
            : '',
        }));
      }
    } else {
      setMaster(masterDefaultValue);
      setMasterList(defaultMasterList);
    }
    setRandomValue(Math.random());
  };

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await postPDF(apiName, {
      poNo: master.poNo,
      hawbNo: master.hawbNo,
    });

    const now = new Date();
    const date = now.toISOString().split('T')[0];
    const time = now.toISOString().split('T')[1];
    const dateTime = formatDateTime(date, time, 'yyyyMMddHHmm');
    blobDownload(
      result,
      enqueueSnackbar,
      `${master.hawbNo}_商業發票_${dateTime}.pdf`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      switch (submitKey) {
        case 'search':
          if (master.hawbNo.length === 0) {
            enqueueSnackbar('【分提單號碼】必填。', {
              variant: 'warning',
            });
            return;
          }
          if (master.poNo.trim.length === 0) {
            handleSearchHawbNo();
          } else {
            handleSearch();
          }
          break;
        case 'searchUnprotected':
          if (master.poNo.length === 0 || master.hawbNo.length === 0) {
            enqueueSnackbar('【訂單號碼】、【分提單號碼】必填。', {
              variant: 'warning',
            });
            return;
          }
          handleSearchUnprotected();
          break;
        case 'login':
          handleLogin();
          break;
        case 'download':
          if (master.poNo.length === 0 || master.hawbNo.length === 0) {
            enqueueSnackbar('【訂單號碼】、【分提單號碼】必填。', {
              variant: 'warning',
            });
            return;
          }
          handleDownload();
          break;
        case 'prepareTel':
          copyPhone(master.poNo, master.hawbNo, submitKey);
          break;
        case 'copyTel':
          //  IOS 無法正常呼叫func後再COPY,所以只COPY,不呼叫copyPhone
          navigator.clipboard.writeText(master.cnContactTel);
          break;
        default:
          console.log(submitKey, master.cnContactTel);
          break;
      }
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const updateData = async (updateObj: Iobject) => {
    if ('poNo' in updateObj || 'hawbNo' in updateObj) {
      setSearchUnprotectedSucceeded(false);
    }
    setMaster({ ...master, ...updateObj });
  };

  const handleReset = async () => {
    setOpenSearchTable(false);
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setMasterList(defaultMasterList);

    setFormError(false);
    setSearchUnprotectedSucceeded(false);
    setRandomValue(Math.random());
  };

  const watermarkStyle: React.CSSProperties = {
    position: 'fixed',
    top: -1000,
    left: -1000,
    width: '300%',
    height: '300%',
    zIndex: -1,
    pointerEvents: 'none',
    background: 'rgba(255, 255, 255, 0)', // 完全透明
    transform: 'rotate(-45deg)',
    backgroundSize: '200px 200px',
  };

  const textStyle: React.CSSProperties = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -170%)',
    whiteSpace: 'nowrap',
    fontSize: '2rem',
    color: 'rgba(0, 0, 0, 0.06)',
  };
  const fullWidthSpace = '\u3000'; // 全形空格的 Unicode 編碼
  const repeatText = new Array(300)
    .fill(`${user?.id?.split('_').pop()}${fullWidthSpace.repeat(4)}`)
    .join(' ');
  return (
    <div id="page-area">
      {userType && <Header />}
      <div className="breadcrumbs-area" />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 商業發票資料查詢
          </div>
        </div>
        {!isAdmin() && master && (
          <div className="input-area">
            <div>
              <Grid container>
                <VcEGrid item className="input-text">
                  收貨人姓名：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={30}
                    value={master.cnContact}
                    name="cnContact"
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container>
                <VcEGrid item className="input-text">
                  訂單編號：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={30}
                    value={master.poNo}
                    name="poNo"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container>
                <VcEGrid item className="input-text">
                  分提單號碼：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={30}
                    value={master.hawbNo}
                    name="hawbNo"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container>
                <VcEGrid item className="input-text">
                  收貨人電話：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={30}
                    value={master.cnContactTel}
                    name="cnContactTel"
                  />
                </Grid>
                <Button
                  className="search-btn"
                  disabled={formError}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<FileCopy />}
                  onClick={() => setSubmitKey('copyTel')}
                  style={{
                    paddingBottom: 0,
                  }}
                >
                  複製
                </Button>
              </Grid>
            </div>
          </div>
        )}
        {isAdmin() && (
          <div className="input-area">
            <div style={watermarkStyle}>
              {new Array(100).fill(null).map((_, index) => (
                <div style={{ ...textStyle, top: `${index * 3.8}%` }}>
                  {repeatText}
                </div>
              ))}
            </div>
            <div>
              <Grid container>
                <VcEGrid item className="input-text">
                  <FormTitle>訂單號碼：</FormTitle>
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={35}
                    value={master.poNo}
                    name="poNo"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
                <VcEGrid item className="input-text">
                  <FormTitle>*分提單號碼：</FormTitle>
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={35}
                    value={master.hawbNo !== null ? master.hawbNo : ''}
                    name="hawbNo"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
                <Grid container spacing={3} justify="center">
                  <Grid item xs={10}>
                    <TextField
                      label="二維碼刷讀"
                      multiline
                      rows={4}
                      variant="outlined"
                      fullWidth
                      value={
                        master.qrCodeData !== null ? master.qrCodeData : ''
                      }
                      onChange={handleChange}
                      inputRef={inputRef}
                      onKeyPress={handleKeyPress}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </div>
        )}
        <Grid container className="button-area">
          {isAdmin() && (
            <>
              <VcEGrid item xs={12} sm={2}>
                <Button
                  className="search-btn"
                  disabled={formError}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<SearchIcon />}
                  onClick={() => setSubmitKey('search')}
                >
                  查詢
                </Button>
              </VcEGrid>
              <Grid item xs={12} sm="auto">
                <Button
                  disabled={formError}
                  type="submit"
                  variant="contained"
                  color="default"
                  startIcon={<PrintIcon />}
                  onClick={() => setSubmitKey('download')}
                >
                  下載發票
                </Button>
              </Grid>
              <Grid item xs={12} sm="auto">
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<RefreshIcon />}
                  onClick={() => handleReset()}
                >
                  重置
                </Button>
              </Grid>
            </>
          )}
          {!isAdmin() && (
            <>
              <VcEGrid item xs={12} sm={2}>
                <Button
                  className="search-btn"
                  disabled={formError}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<SearchIcon />}
                  onClick={() => setSubmitKey('login')}
                >
                  商業發票
                </Button>
              </VcEGrid>
              <VcEGrid item xs={12} sm="auto">
                <Button
                  className="search-btn"
                  disabled={formError || searchUnprotectedSucceeded}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<SearchIcon />}
                  onClick={() => setSubmitKey('searchUnprotected')}
                >
                  查詢
                </Button>
              </VcEGrid>
              <VcEGrid item xs={12} sm="auto">
                <Button
                  className="search-btn"
                  disabled={formError || master.cnContactTel.length === 0}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<LocalPhone />}
                  onClick={() => setSubmitKey('prepareTel')}
                  style={{
                    backgroundColor: 'green',
                  }}
                >
                  電話
                </Button>
              </VcEGrid>
              <VcEGrid item xs={12} sm="auto">
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<RefreshIcon />}
                  onClick={() => handleReset()}
                >
                  重置
                </Button>
              </VcEGrid>
            </>
          )}
        </Grid>
      </form>

      {isAdmin() && openSearchTable && (
        <form className="form-area">
          <div
            className={`ag-theme-alpine ${classes.root}`}
            style={{ height: `${rowData.length * 50 + 100}px` }}
          >
            <AgGridReact
              ref={gridRef}
              rowData={rowData}
              gridOptions={gridOptions}
              onGridReady={onGridReady}
            />
          </div>
        </form>
      )}

      {!userType && userType && isAdmin() && !openSearchTable && (
        <form className="form-area">
          <div className="input-area">
            <div>
              <Grid container>
                <VcEGrid item className="input-text">
                  主號：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={4}
                    value={master.qrCodeData}
                    name="declNo4"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
                <VcEGrid item className="input-text">
                  報單號碼：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={4}
                    value={master.qrCodeData}
                    name="declNo4"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <Grid container>
                <VcEGrid item className="input-text">
                  <FormTitle>實名認證：</FormTitle>
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={4}
                    value={master.qrCodeData || 'Y'}
                    name="declNo2"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
                <VcEGrid item className="input-text">
                  委任狀態：
                </VcEGrid>
                <Grid item>
                  <Input
                    maxLength={4}
                    value={master.qrCodeData || 'N'}
                    name="declNo3"
                    onChange={(e) => {
                      inputChange(updateData)(e);
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        </form>
      )}
      {masterList &&
        masterList.ehuPoMasterDTOs.length > 0 &&
        isAdmin() &&
        !openSearchTable &&
        masterList.ehuPoMasterDTOs.map((ehuPo: Imaster, index: number) => (
          <Invoiceform
            key={ehuPo.poNo}
            index={index}
            ehuPo={ehuPo}
            userName={user.name}
          />
        ))}
    </div>
  );
};
export default InvoiceQry;
